/* eslint-disable sort-keys */
import {
    COLOR,
    COUNTRY,
    GRAPE_CONTENT,
    MANUFACTURER,
    NET_VOLUME,
    REGION,
    STRONGNESS,
    SUGAR_TYPE,
    TEMPERATURE_FROM,
    TEMPERATURE_TO,
    YEAR,
} from 'modules/product-card/constants/characteristics';

export const HEADER = [COUNTRY, REGION, COLOR, SUGAR_TYPE, GRAPE_CONTENT, MANUFACTURER, STRONGNESS, NET_VOLUME];
export const DETAILED = [YEAR, TEMPERATURE_FROM, TEMPERATURE_TO];
export const TABLET = [...HEADER, ...DETAILED];

export const FINE_AND_RARE_CHARACTERISTICS = {
    HEADER,
    DETAILED,
    TABLET,
};
